export const figure = `
    figure {
        margin: unset;

        img {
            width: 100%;
        }
    }  
`